// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const showMoreText = (data) => {
  return `${
    data.isShowingMore
      ? `${__('Show less', 'vn')} <i class="vn-icons-arrow-up-circle"></i>`
      : `${__('Show more', 'vn')} <i class="vn-icons-arrow-down-circle"></i>`
  }`
}

export default showMoreText
